define(function (require, exports, module) {
    'use strict';

    var UploadError = require('./UploadError');

    /**
     * @constructor
     * @extends {UploadError}
     * @param {Error} stack
     * @param {string} source
     * @param {string} error
     */
    function UnknownError(stack, source, error) {
        UploadError.apply(this, arguments);

        var reason = error.replace(/[^\w]/g, '-');

        this.radarName = this.radarName.replace('{ERROR}', reason);
        this.message = this.message.replace('{ERROR}', error);
        this.error = error;
    }

    UnknownError.prototype = Object.assign(Object.create(UploadError.prototype), {
        constructor: UnknownError,
        className: 'UnknownError',
        radarName: 'error_{SOURCE}_unknown-{ERROR}',
        message: 'Ошибка {ERROR}.',
        error: '',

        toLogStringPattern: '[{TIME}] {ID} {SOURCE} {CLASS_NAME} { {META} }: {ERROR}',

        toLogString: function () {
            var result = UploadError.prototype.toLogString.apply(this, arguments);

            result = result.replace('{ERROR}', String(this.error));

            return result;
        },

        getDetails: function () {
            var details = UploadError.prototype.getDetails.apply(this, arguments);

            details.error = String(this.error);

            return details;
        },
    });

    module.exports = UnknownError;
});
